import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-progress-grid',
  templateUrl: './project-progress-grid.component.html',
  styleUrls: ['./project-progress-grid.component.css']
})
export class ProjectProgressGridComponent implements OnInit {

  title="Project Progress";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/project-progress/project-progress-grid/project-progress-grid.component.ts